import { useEffect, useState } from "react";
import card_icon from "../../adminassets/img/illustrations/card-ratings-illustration.png";
import card_sicon from "../../adminassets/img/illustrations/card-session-illustration.png";
import card_wicon1 from "../../adminassets/img/products/card-weekly-sales-watch.png";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import Loading from '../Loading';
import Lottie from "lottie-react";
import medium from "../../adminassets/img/language.png";
import grade from "../../adminassets/img/grade.png";
import subject from "../../adminassets/img/subject.png";

export default function AdminDashboard() {

  const [details, setDetails] = useState();
  const [totalMedium, setTotalMedium] = useState([]);
  const [totalSubject, setTotalSubject] = useState([]);
  const [totalGrade, setTotalGrade] = useState([]);
  const adminDetails = useSelector((state) => state.userSlice);
  const navigate = useNavigate();
  const adminToken = localStorage.getItem("authAdminToken");
  const [loading, setLoading] = useState(true)

  // All Details Section
  const fetchAllDetails = async () => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/getDashboard`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        "Authorization": `Bearer ${adminToken}`
      },
    });

    return response.json();
  };

  useEffect(() => {
    setLoading(true)
    fetchAllDetails().then((res) => {
      if (res.status) {
        setTotalMedium(res?.adminDashboardObj?.total_medium);
        setTotalSubject(res?.adminDashboardObj?.total_subject);
        setTotalGrade(res?.adminDashboardObj?.total_grade);
        setDetails(res?.adminDashboardObj);
        setLoading(false)
      } else {
        toast.error("Failed to load Details. Please try again.");
      }
    }).catch((err) => {
      toast.error("Something went wrong! Please try again later.");
    });

  }, [])

  let currentDate = new Date();

  const previous = details?.total_dashboardSearch_previous_year ?? 0;
  const thisyear = details?.total_dashboardSearch_year ?? 0;
  const value = previous + thisyear;

  const previousYearPer = previous !== 0 ? (value / previous) * 100 : 0;
  const thisYearPer = thisyear !== 0 ? (value / thisyear) * 100 : 0;

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />

      {loading ?
        <Loading />
        :
        <div className="layout-wrapper layout-content-navbar">
          <div className="layout-container">

            <div className="layout-page">

              {/* Content wrapper */}
              <div className="content-wrapper">

                <div className="container-xxl flex-grow-1 container-p-y d-flex justify-content-center">
                  <div className="w-100" style={{ maxWidth: '88em' }}>
                    <div className="row g-6 mb-6">

                      {/* Sales Overview */}
                      <div className="col-lg-6">
                        <div className="card h-100">

                          <div className="card-body d-flex justify-content-between flex-wrap gap-4">
                            <div className="d-flex align-items-center gap-3">
                              <div className="avatar">
                                <div className="avatar-initial bg-label-primary rounded">
                                  <i className="icon-base ri ri-user-star-line icon-24px"></i>
                                </div>
                              </div>
                              <div className="card-info">
                                <h5 className="mb-0">{details?.total_users}</h5>
                                <p className="mb-0">Total User</p>
                              </div>
                            </div>
                            <div className="d-flex align-items-center gap-3">
                              <div className="avatar">
                                <div className="avatar-initial bg-label-warning rounded">
                                  <i className="icon-base ri ri-pie-chart-2-line icon-24px"></i>
                                </div>
                              </div>
                              <div className="card-info">
                                <h5 className="mb-0">&#8377;{details?.total_income}</h5>
                                <p className="mb-0">Total Income</p>
                              </div>
                            </div>
                            <div className="d-flex align-items-center gap-3">
                              <div className="avatar">
                                <div className="avatar-initial bg-label-info rounded">
                                  <i className="icon-base ri ri-arrow-left-right-line icon-24px"></i>
                                </div>
                              </div>
                              <div className="card-info">
                                <h5 className="mb-0">{details?.total_subscriptions}</h5>
                                <p className="mb-0">Total Subscription</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>


                      {/* Ratings Section */}
                      <div className="col-lg-3 col-sm-6">
                        <div className="card h-100">
                          <div className="row">
                            <div className="col-6">
                              <div className="card-body">
                                <div className="card-info mb-5">
                                  <h6 className="mb-2 text-nowrap">Total Subscription</h6>
                                  <div className="badge bg-label-primary rounded-pill lh-xs">Year of {currentDate.getFullYear()}</div>
                                </div>
                                <div className="d-flex align-items-center">
                                  <h4 className="mb-0 me-2 text-primary">&#8377;{details?.total_subscription_year}</h4>
                                  {/* <p className="mb-0 text-success">+15.6%</p> */}
                                </div>
                              </div>
                            </div>
                            <div className="col-6 text-end d-flex align-items-end">
                              <div className="card-body pb-0 pt-7">
                                <img src={card_icon} alt="Ratings" className="img-fluid" width="95" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>


                      {/* Sessions Section */}
                      <div className="col-lg-3 col-sm-6">
                        <div className="card h-100">
                          <div className="row">
                            <div className="col-6">
                              <div className="card-body">
                                <div className="card-info mb-5">
                                  <h6 className="mb-2 text-nowrap">Total Subscription</h6>
                                  <div className="badge bg-label-success rounded-pill lh-xs">Month of {currentDate.toLocaleString("en-US", { month: "long" })}</div>
                                </div>
                                <div className="d-flex align-items-center">
                                  <h4 className="mb-0 me-2 text-primary">&#8377;{details?.total_subscription_month}</h4>
                                  {/* <p className="mb-0 text-danger">-25.5%</p> */}
                                </div>
                              </div>
                            </div>
                            <div className="col-6 text-end d-flex align-items-end">
                              <div className="card-body pb-0 pt-7">
                                <img src={card_sicon} alt="Ratings" className="img-fluid" width="81" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>



                      <div className="col-lg-12 col-xl-6 mt-4">
                        <div className="card h-100 swiper-container swiper-container-horizontal swiper text-bg-primary swiper-initialized swiper-horizontal swiper-backface-hidden" id="swiper-weekly-sales-with-bg">
                          <div className="swiper-wrapper">
                            <div className="swiper-slide pb-5 swiper-slide-prev" role="group" aria-label="1 / 3" data-swiper-slide-index="0" style={{ width: "684px" }}>
                              <div className="row">
                                <div className="col-12">
                                  <h5 className=" mb-0">Medium</h5>
                                  <h6 className="d-flex align-items-center gap-2">
                                    <div className="mt-3 ">{totalMedium[0]?.type?.charAt(0).toUpperCase() + totalMedium[0]?.type?.slice(1)}</div>
                                    <div className="d-flex align-items-center text-success mt-2">
                                      <i className="icon-base ri ri-arrow-up-s-line mt-n1"></i>
                                    </div>
                                  </h6>
                                </div>
                                <div className="col-lg-7 col-md-9 col-12 order-2 order-md-1">
                                  <p className=" mt-0 mt-md-4 mb-4 py-1 ">Top Mediums</p>
                                  <div className="row g-4">
                                    <div className="col-sm-12">
                                      <ul className="list-unstyled mb-0 d-flex flex-wrap gap-5">
                                        {totalMedium.map((medium, index) => {
                                          return <li key={index} className="d-flex mb-5 align-items-center">
                                            <p className="mb-0 me-3 weekly-sales-text-bg-primary fw-medium text-white">{medium.occurance}</p>
                                            <p className="mb-0 text-truncate ">{medium?.type?.charAt(0).toUpperCase() + medium?.type?.slice(1)}</p>
                                          </li>
                                        })}

                                      </ul>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-5 col-md-3 col-12 order-1 order-md-2 my-2 my-md-0 text-center">
                                  <img src={medium} alt="weekly sales" width="240" className="weekly-sales-img me-6" />
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* <div className="swiper-pagination swiper-pagination-clickable swiper-pagination-bullets swiper-pagination-horizontal">
                            <span className="swiper-pagination-bullet" tabIndex="0" role="button" aria-label="Go to slide 1"></span>
                            <span className="swiper-pagination-bullet swiper-pagination-bullet-active" tabIndex="0" role="button" aria-label="Go to slide 2" aria-current="true"></span>
                            <span className="swiper-pagination-bullet" tabIndex="0" role="button" aria-label="Go to slide 3"></span>
                            </div> */}
                          <span className="swiper-notification" aria-live="assertive" aria-atomic="true"></span></div>
                      </div>




                      {/* Total Visits */}
                      <div className="col-xl-6 col-sm-6">
                        <div className="card">
                          <div className="card-header">
                            <div className="d-flex justify-content-between flex-wrap gap-2">
                              <p className="d-block mb-0 text-body">Total Question Search</p>
                              <div className="d-flex align-items-center text-success">
                                {/* <p className="mb-0"></p> */}
                                {/* <i className="icon-base ri ri-arrow-up-s-line icon-22px"></i> */}
                              </div>
                            </div>
                            <h4 className="mb-0">{details?.total_dashboardSearch}</h4>
                          </div>
                          <div className="card-body">
                            <div className="row">
                              <div className="col-4">
                                <div className="d-flex gap-2 align-items-center mb-2">
                                  {/* <div className="avatar avatar-xs flex-shrink-0">
                                    <div className="avatar-initial rounded bg-label-warning">
                                      <i className="icon-base ri ri-pie-chart-2-line icon-16px"></i>
                                    </div>
                                  </div> */}
                                  {/* <p className="mb-0">Previous Year</p> */}
                                  <div className="badge bg-label-warning rounded-pill lh-xs">Year of {currentDate.getFullYear() - 1}</div>
                                </div>
                                <h4 className="mb-2">{previousYearPer}%</h4>
                                <p className="mb-0">{details?.total_dashboardSearch_previous_year}</p>
                              </div>
                              <div className="col-4">
                                <div className="divider divider-vertical">
                                  <div className="divider-text">
                                    <span className="badge-divider-bg bg-label-secondary p-2">VS</span>
                                  </div>
                                </div>
                              </div>
                              <div className="col-4 text-end">
                                <div className="d-flex gap-2 justify-content-end align-items-center mb-2">
                                  {/* <p className="mb-0">This Year</p> */}
                                  <div className="badge bg-label-primary rounded-pill lh-xs">Year of {currentDate.getFullYear()}</div>
                                  {/* <div className="avatar avatar-xs flex-shrink-0">
                                    <div className="avatar-initial rounded bg-label-primary">
                                      <i className="icon-base ri ri-mac-line icon-16px"></i>
                                    </div>
                                  </div> */}
                                </div>
                                <h4 className="mb-2">{thisYearPer}%</h4>
                                <p className="mb-0">{details?.total_dashboardSearch_year}</p>
                              </div>
                            </div>
                            <div className="d-flex align-items-center mt-4">
                              <div className="progress w-100 rounded" style={{ height: "8px" }}>
                                <div
                                  className="progress-bar bg-warning"
                                  style={{ width: `${previousYearPer}%` }}
                                  role="progressbar"
                                  aria-valuenow="20"
                                  aria-valuemin="0"
                                  aria-valuemax="100"></div>
                                <div
                                  className="progress-bar bg-primary"
                                  role="progressbar"
                                  style={{ width: `${thisYearPer}%` }}
                                  aria-valuenow="80"
                                  aria-valuemin="0"
                                  aria-valuemax="100"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>


                      {/* Sales This Months */}
                      {/* <div className="col-lg-6 col-sm-6 col-xl-3">
                        <div className="card h-100">
                          <div className="card-header">
                            <h5 className="mb-0">Sales This Month</h5>
                          </div>
                          <div className="card-body">
                            <div className="card-info">
                              <p className="mb-0">Total Sales This Month</p>
                              <h5 className="mb-0">$28,450</h5>
                            </div>
                            <div id="saleThisMonth"></div>
                          </div>
                        </div>
                      </div> */}

                      <div className="col-lg-12 col-xl-6 mt-4">
                        <div className="card h-100 swiper-container swiper-container-horizontal swiper text-bg-primary swiper-initialized swiper-horizontal swiper-backface-hidden" id="swiper-weekly-sales-with-bg">
                          <div className="swiper-wrapper">
                            <div className="swiper-slide pb-5 swiper-slide-prev" role="group" aria-label="1 / 3" data-swiper-slide-index="0" style={{ width: "684px" }}>
                              <div className="row">
                                <div className="col-12">
                                  <h5 className=" mb-0">Grade</h5>
                                  <h6 className="d-flex align-items-center gap-2">
                                    <div className="mt-3 ">{totalGrade[0]?.type?.charAt(0).toUpperCase() + totalGrade[0]?.type?.slice(1)}</div>
                                    <div className="d-flex align-items-center text-success mt-2">
                                      <i className="icon-base ri ri-arrow-up-s-line mt-n1"></i>
                                    </div>
                                  </h6>
                                </div>
                                <div className="col-lg-7 col-md-9 col-12 order-2 order-md-1">
                                  <p className=" mt-0 mt-md-4 mb-4 py-1 ">Top Grades</p>
                                  <div className="row g-4">
                                    <div className="col-sm-12">
                                      <ul className="list-unstyled mb-0 d-flex flex-wrap gap-5">
                                        {totalGrade.map((grade, index) => {
                                          return <li key={index} className="d-flex mb-5 align-items-center">
                                            <p className="mb-0 me-3 weekly-sales-text-bg-primary fw-medium text-white">{grade.occurance}</p>
                                            <p className="mb-0 text-truncate ">{grade?.type?.charAt(0)?.toUpperCase() + grade?.type?.slice(1)}</p>
                                          </li>
                                        })}

                                      </ul>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-5 col-md-3 col-12 order-1 order-md-2 my-2 my-md-0 text-center">
                                  <img src={grade} alt="weekly sales" width="240" className="weekly-sales-img" />
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* <div className="swiper-pagination swiper-pagination-clickable swiper-pagination-bullets swiper-pagination-horizontal">
                            <span className="swiper-pagination-bullet" tabIndex="0" role="button" aria-label="Go to slide 1"></span>
                            <span className="swiper-pagination-bullet swiper-pagination-bullet-active" tabIndex="0" role="button" aria-label="Go to slide 2" aria-current="true"></span>
                            <span className="swiper-pagination-bullet" tabIndex="0" role="button" aria-label="Go to slide 3"></span>
                            </div> */}
                          <span className="swiper-notification" aria-live="assertive" aria-atomic="true"></span></div>
                      </div>

                      <div className="col-lg-12 col-xl-6 mt-4">
                        <div className="card h-100 swiper-container swiper-container-horizontal swiper text-bg-primary swiper-initialized swiper-horizontal swiper-backface-hidden" id="swiper-weekly-sales-with-bg">
                          <div className="swiper-wrapper">
                            <div className="swiper-slide pb-5 swiper-slide-prev" role="group" aria-label="1 / 3" data-swiper-slide-index="0" style={{ width: "684px" }}>
                              <div className="row">
                                <div className="col-12">
                                  <h5 className=" mb-0">Subject</h5>
                                  <h6 className="d-flex align-items-center gap-2">
                                    <div className="mt-3 ">{totalSubject[0]?.type?.charAt(0)?.toUpperCase() + totalSubject[0]?.type?.slice(1)}</div>
                                    <div className="d-flex align-items-center text-success mt-2">
                                      <i className="icon-base ri ri-arrow-up-s-line mt-n1"></i>
                                    </div>
                                  </h6>
                                </div>
                                <div className="col-lg-7 col-md-9 col-12 order-2 order-md-1">
                                  <p className=" mt-0 mt-md-4 mb-4 py-1 ">Top Subjects</p>
                                  <div className="row g-4">
                                    <div className="col-sm-12">
                                      <ul className="list-unstyled mb-0 d-flex flex-wrap gap-5">
                                        {totalSubject.map((subject, index) => {
                                          return <li key={index} className="d-flex mb-5 align-items-center">
                                            <p className="mb-0 me-3 weekly-sales-text-bg-primary fw-medium text-white">{subject.occurance}</p>
                                            <p className="mb-0 text-truncate ">{subject?.type?.charAt(0).toUpperCase() + subject?.type?.slice(1)}</p>
                                          </li>
                                        })}

                                      </ul>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-5 col-md-3 col-12 order-1 order-md-2 my-2 my-md-0 text-center">
                                  <img src={subject} alt="weekly sales" className="weekly-sales-img me-6" style={{width:"150px"}}/>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* <div className="swiper-pagination swiper-pagination-clickable swiper-pagination-bullets swiper-pagination-horizontal">
                            <span className="swiper-pagination-bullet" tabIndex="0" role="button" aria-label="Go to slide 1"></span>
                            <span className="swiper-pagination-bullet swiper-pagination-bullet-active" tabIndex="0" role="button" aria-label="Go to slide 2" aria-current="true"></span>
                            <span className="swiper-pagination-bullet" tabIndex="0" role="button" aria-label="Go to slide 3"></span>
                            </div> */}
                          <span className="swiper-notification" aria-live="assertive" aria-atomic="true"></span></div>
                      </div>

                    </div>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>}

    </>
  )
}
